<template>
  <div class="switch-totalprom">
    <div
      class="switch-totalprom__total"
      :class="{ 'switch-totalprom__total--active': typeStats === 1 }"
      @click="onClick(1)"
    >
      {{ $t('filter.total') }}
    </div>
    <div
      class="switch-totalprom__prom"
      :class="{ 'switch-totalprom__prom--active': typeStats === 0 }"
      @click="onClick(0)"
    >
      {{ $t('filter.average') }}
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'TypeCategoryStats',
  data() {
    return {
      typeStats: 1,
    };
  },
  computed: {
    ...mapGetters('filterGeneral', ['getStadisticId']),
  },
  watch: {
    getStadisticId: {
      immediate: true,
      handler(newValue) {
        if (newValue !== this.typeStats) {
          this.typeStats = newValue;
        }
      },
    },
  },
  methods: {
    ...mapMutations('filterGeneral', ['setStadisticId']),
    onClick(statsType) {
      if (this.typeStats !== statsType) {
        this.typeStats = statsType;
        this.setStadisticId(statsType);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.switch-totalprom {
  width: 195px;
  height: 38px;
  background: white;
  display: inline-flex;
  border-radius: 4px;
  overflow: hidden;
  border: solid 1px #d2d4d8;
  &__total {
    width: 86px;
    height: 38px;
    font-family: 'Avenir-Demi';
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 38px;
    letter-spacing: normal;
    text-align: center;
    color: #363636;

    &:hover {
      cursor: pointer;
    }
    &--active {
      color: white;
      border: solid 1px #75bf23;
      background-color: #7ed321;
    }
  }
  &__prom {
    width: 109px;
    height: 38px;
    font-family: 'Avenir-Demi';
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 38px;
    letter-spacing: normal;
    text-align: center;
    color: #363636;
    &:hover {
      cursor: pointer;
    }
    &--active {
      color: white;
      border: solid 1px #75bf23;
      background-color: #7ed321;
    }
  }
}
</style>
